import SectionHeader from "@/components/feature/panel/SectionHeader";
import EmptyState from "@/components/feature/panel/EmptyState";
import { useAuditLog } from "@/hooks/useAdmin";

function formatDateTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString("tr-TR", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const ACTION_LABELS: Record<string, string> = {
  rol_guncelle: "Rol Güncelle",
  paket_olustur: "Paket Oluştur",
  paket_guncelle: "Paket Güncelle",
  paket_sil: "Paket Sil",
  ticket_durum: "Talep Durumu",
};

const ENTITY_LABELS: Record<string, string> = {
  kullanici: "Kullanıcı",
  paket: "Paket",
  destek: "Destek",
};

export default function AdminDenetimKaydi() {
  const { data, loading, error, reload } = useAuditLog();
  const list = data ?? [];

  return (
    <div className="space-y-6">
      <SectionHeader
        title="Denetim Kaydı"
        description="Yönetici işlemlerine ait denetim logları."
      />

      {loading ? (
        <EmptyState icon="ri-loader-4-line" title="Yükleniyor..." />
      ) : error ? (
        <div className="rounded-lg border border-background-200 bg-background-50 p-6 text-center">
          <p className="text-sm text-foreground-600">{error}</p>
          <button
            type="button"
            onClick={reload}
            className="mt-4 inline-flex items-center gap-2 whitespace-nowrap px-4 py-2 rounded-md text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            <i className="ri-refresh-line" aria-hidden="true"></i>
            Tekrar dene
          </button>
        </div>
      ) : list.length === 0 ? (
        <EmptyState
          icon="ri-history-line"
          title="Henüz denetim kaydı yok"
          description="Yönetici işlemleri yapıldıkça burada kayıt oluşacak."
        />
      ) : (
        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200 bg-background-100/60">
                  <th className="px-4 py-3 text-left font-semibold text-foreground-700">Yönetici</th>
                  <th className="px-4 py-3 text-left font-semibold text-foreground-700">İşlem</th>
                  <th className="px-4 py-3 text-left font-semibold text-foreground-700">Varlık</th>
                  <th className="px-4 py-3 text-left font-semibold text-foreground-700">Detay</th>
                  <th className="px-4 py-3 text-left font-semibold text-foreground-700">Tarih</th>
                </tr>
              </thead>
              <tbody>
                {list.map((l) => (
                  <tr key={l.id} className="border-b border-background-200 hover:bg-background-100/40 transition-colors">
                    <td className="px-4 py-3 font-medium text-foreground-900 whitespace-nowrap">
                      {l.userName}
                    </td>
                    <td className="px-4 py-3">
                      <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap bg-secondary-100 text-secondary-900">
                        {ACTION_LABELS[l.action] ?? l.action}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">
                      {ENTITY_LABELS[l.entity] ?? l.entity}
                    </td>
                    <td className="px-4 py-3 text-foreground-600 max-w-[320px] truncate">
                      {l.details || "—"}
                    </td>
                    <td className="px-4 py-3 text-foreground-500 whitespace-nowrap">
                      {formatDateTime(l.createdAt)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}